module.exports = __webpack_public_path__ + "static/media/boxToolActive.ae8d91b8.png";